<template>
    <messages :message-items="mails" :props="props"
              @read-mail="onReadMail"
              @tabs-change="onTabsChange"
              @all-read="onAllRead"
              @previous="onPrevious"
              @next="onNext"
              @search="onSearch"></messages>
</template>

<script>
import Messages from './../Messages'
import GlobalEvent from '@/plugin/Events/GlobalEvent'
export default {
    components: {
        Messages
    },
    data() {
        let $this = this
        return {
            messageItems: [],
            props:{
                sendUser: 'publisher',
                sendDate: 'publishTime',
                title: 'noticeTitle',
                content: 'noticeContent',
                newMail: 'newMail'
            },
            tabsName: 'unread',
            timeIndex: 0,
            search:{ searchContent: '' }
        };
    },
    methods: {
        //全读
        onAllRead () {
            const mailIdList = [],$this = this, mailArray = this.messageItems

            for (let i = 0; i < mailArray.length; i++) {
                const cache = mailArray[i]
                if (cache.flag === '0'){
                    mailIdList.push(cache.rowCode)
                }
            }
            if (mailIdList.length === 0){
                this.$message.info('没有未读消息.')
                return
            }
            this.$confirm('该操作将会使得所有未读消息进入已读状态,是否继续.', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                $this.allReadMail(mailIdList)
            }).catch(()=>{
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        allReadMail (mails) {
            const $this = this
            this.$http.postHandle('标记中.',this.$url.notices.read, {"flag":2,
                "rowCode": mails.toString()}).then(response=>{
                $this.onTabsChange(this.paging, this.search)
            })
        },
        onPrevious(){
            if (this.paging.canPrevious()){
                this.refreshMailList(this.paging.lessIndex(), this.search)
            }else{
                this.$message.info('无法继续翻页.')
            }
        },
        onNext(){
            if (this.paging.canNext()){
                this.refreshMailList(this.paging.addIndex(), this.search)
            }else{
                this.$message.info('无法继续翻页.')
            }
        },
        onListItemClick(index) {
            this.currentIndex = index
            this.currentItem = this.messageItems[index]
            this.currentItem.newMessage = false
        },
        onRead(){
            let data = this.$refs['mail'].getCheckedItems()
            this.$message.info(JSON.stringify(data))
        },
        onInitial () {
            this.refreshMailList(this.paging, {})
        },
        refreshMailList (paging, search) {
            const $this = this, searchData = this.Tools.get().ObjectTools.merge(paging, search)
            this.$http.post(this.$url.notices.inbox, searchData).then(
                response =>{
                    const {data, pageCount} = response
                    $this.messageItems = data
                    $this.paging.setTotal(pageCount)
                })
        },
        onReadMail (mail, callback) {
            const $this = this, handelData = {rowCode: mail.rowCode, flag: 2}
            this.$http.post(this.$url.notices.read, handelData).then(response=>{
                mail.flag = '2'
                GlobalEvent.mail.handle()
            })
        },
        onTabsChange (name) {
            this.tabsName = name
            if (!this.paging){
                this.paging = this.Paging.default()
            }
            let data = {flag: null}
            switch (name) {
                case 'unread':
                    this.paging.initialIndex().setSize(99999)
                    data.flag = '0'
                    break;
                case 'read':
                    this.paging.initialIndex().setSize(10)
                    data.flag = '2'
                    break;
                case 'all':
                    data.flag = '-1'
                    this.paging.initialIndex().setSize(10)
                    break;
            }
            this.search = data
            this.refreshMailList(this.paging, this.search)
        },
        onSearch(search){
            const $this = this
            this.search = {searchContent: search}
            if (this.tabsName !== 'unread'){
                clearTimeout(this.timeIndex)
                this.timeIndex = setTimeout(()=>{
                    $this.refreshMailList(this.paging.initialIndex(), this.search)
                },2*1000)
            }
        }
    },
    computed: {
        mails() {
            const search = !this.Tools.get().StringTools.isNullOrEmpty(this.search.searchContent)
            if (this.tabsName === 'unread' && search){
                const cacheMail = []
                for (let i = 0; i < this.messageItems.length; i++) {
                    const mail = this.messageItems[i]
                    if (mail.noticeTitle.indexOf(this.search.searchContent) > 0 ||
                        mail.noticeContent.indexOf(this.search.searchContent) > 0){
                        cacheMail.push(mail)
                    }
                }
                return cacheMail
            }else{
                return this.messageItems
            }
        }
    },
    mounted() {
        if (!this.paging){
            this.paging = this.Paging.default()
        }
    }
}
</script>

<style scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/Test/index.vue"
}
</vue-filename-injector>
